import { cn } from "@/lib/utils";
import React, { HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLDivElement>;
}>;

const SelectorButtonContainer: React.FC<Props> = ({ children, className }) => {
  return (
    <div className={cn("flex rounded-lg border border-border", className)}>
      {children}
    </div>
  );
};

export default SelectorButtonContainer;
